import { apiService } from "@/_services";
import { additionalYSpace, timeParseNull2 } from "@/_core/_helpers/_helpers";
import {
  createExcelForStrategy,
  highlightOnOff,
  readyToSimulate,
  writeStrategySummary
} from "@/_core/data/Optimizer";

// === OPTIMIZER: initiate strategy === //
export function getInitialStrategyValues(
  _this,
  strategy,
  idx,
  asset = "currencies",
  pk = null
) {
  const query_params = {
    format: "json",
    spot: _this.spot,
    data: JSON.stringify(_this.hedgeTemplate),
    strategy: JSON.stringify([strategy]),
    idx: idx,
    costs: _this.userCosts,
    asset: asset
  };
  let params = {
    method: "POST",
    endpoint: "initiate_strategy",
    content_type: "application/json",
    query_params: pk ? { ...query_params, pk } : query_params
  };
  return apiService
    .getAll(params)
    .then(data => {
      let summary = data[0]["summary"];
      data = data[0]["all"];
      data.forEach(function(d) {
        d.date = timeParseNull2(d.date);
        d.premium_value_date = timeParseNull2(d.premium_value_date);
        d.trade_date = timeParseNull2(d.trade_date);
        d.fixation_date = timeParseNull2(d.fixation_date);
        d.fixing_date = timeParseNull2(d.fixing_date);
        d.value_date = timeParseNull2(d.value_date);
        d.asian_fixing_start_date = timeParseNull2(d.asian_fixing_start_date);
        d.cash_flow = 0;
        d.balance = 0;
      });
      data.forEach(function(d) {
        delete d.row;
      });
      _this.strategies[idx].data = data;
      _this.strategies[idx].simulated = false;
      _this.strategies[idx].simulations = [];
      _this.strategies.forEach(function(d) {
        d.show = false;
      });
      _this.strategies[idx].calculated = true;
      _this.strategies[idx].show = true;
      _this.selectedStrategy = _this.strategies[idx];
      _this.hedgeData = data;
      createExcelForStrategy(_this, data, strategy);
      _this.minMaxYAxisRates = _this.processData.minMax(
        _this.hedgeData,
        "strike",
        "strike",
        [_this.minMaxYAxisHist[0], _this.minMaxYAxisHist[1]]
      );
      _this.minMaxYAxisRates = _this.processData.minMax(
        _this.hedgeData,
        "fwd",
        "fwd",
        [_this.minMaxYAxisRates[0], _this.minMaxYAxisRates[1]]
      );
      _this.minMaxYAxisRates = _this.processData.minMax(
        _this.hedgeData.filter(
          d =>
            d.derivative_type.indexOf("OUT") > -1 ||
            d.derivative_type.indexOf("IN") > -1
        ),
        "barrier",
        "barrier",
        [_this.minMaxYAxisRates[0], _this.minMaxYAxisRates[1]]
      );
      _this.minMaxYAxisRates = additionalYSpace(_this.minMaxYAxisRates, 0.05);
      _this.renderCharts += 1;
      writeStrategySummary(_this, idx, summary);
      _this.strategies[idx].showLoading = false;
      highlightOnOff(_this, "highlightBorder");
      readyToSimulate(_this);
    })
    .catch(function(error) {
      _this.strategies[idx].showLoading = false;
      console.log(error);
    });
}
